import api from '@/api';

const resource = 'merenda/tipo-movimento-deposito-escola';

export default {
  criarTipoMovimentoDeposito( data ) {
    return api.post( `${resource}`, data );
  },

  editarTipoMovimentoDeposito( data ) {
    return api.put( `${resource}/${data.identificadortipomovimento}`, data);
  },

  deletarTipoMovimentoDeposito( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarTiposMovimentosDeposito(data) {
    return api.get( `${resource}`,  {
      params: data
    }  );
  }
};
